var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "product-nav-row" }, [
    _c(
      "div",
      { staticClass: "product-nav-row__arenas" },
      [
        _c("ArenaStatusIndicator", {
          staticClass: "product-nav-arenas",
          attrs: { size: "xs" },
        }),
      ],
      1
    ),
    !_vm.isPopupOpen
      ? _c(
          "div",
          { staticClass: "product-nav-row__menu" },
          [_c("BurgerMenu", { attrs: { embedded: "" } })],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }